import { render, staticRenderFns } from "./PetPermit.vue?vue&type=template&id=3470a080"
import script from "./PetPermit.vue?vue&type=script&lang=js"
export * from "./PetPermit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports